export const isInteger = (value) => {
  const regex = /^\d+$/;
  if (value && value.match(regex)) {
    return true;
  }

  return false;
}

export default {};